import './bootstrap';
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import { Application } from '@splinetool/runtime';
window.Spline = Application;

Alpine.data('cursor', (enabled = true) => ({
    cursor: null,
    cursorHtml: '',
    follow() {
        this.cursor.classList.remove('scale-0', 'opacity-0');
    },
    unfollow() {
        this.cursor.classList.add('scale-0', 'opacity-0');
    },
    tracker(e) {
        this.cursor.style.top = e.clientY + 'px';
        this.cursor.style.left = e.clientX + 'px';
    },
    init() {
        if (!enabled) {
            return;
        }
		const top = this.$el.getBoundingClientRect().top + window.scrollY;
        this.cursor = this.$root.querySelector('cursor') ?? this.$root.querySelector('.cursor');
        this.cursor.classList.add('pointer-events-none', 'fixed', 'z-10', '-translate-y-1/2', '-translate-x-1/2', 'transition', 'duration-700', 'ease-[cubic-bezier(0.215,0.610,0.355,1)]');
        this.$root.append(this.cursor);
		if (this.$el.getBoundingClientRect().top !== 0) {
			this.unfollow();
		}
        this.$root.addEventListener('mouseenter', () => {
            this.follow();
        });
        this.$root.addEventListener('mousemove', (e) => {
			const rect = this.$el.getBoundingClientRect();
			if (top === 0) {
				if (e.offsetY > 0 && e.pageY < rect.height) {
					this.follow();
					this.tracker(e);
				} else {
					this.unfollow();
				}
			} else {
				this.tracker(e);
			}
        });
        this.$root.addEventListener('mouseleave', () => {
            this.unfollow();
        });
    },
}));

Livewire.start()
